// @vue/component
import { subjectLogs } from "@/api/subjects";
import printJS from "print-js";
export default {
  name: "Look",
  components: {},
  mixins: [],
  props: {
    subject: {
      type: Object,
      require: true
    },
    project: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      log_list: [],
      cellStyle: {
        textAlign: "center"
      },
      projectGroup: {
        "62f9f0dcc43d533bd20f99a1": "组别",
        "6476bc96ad1ad354ffb4b15c": "组别",
        "672c28f5ca8f158893345f2d": "组别",
        "66f4f33fd9db58c6e3e199e2": "组别",
        "6513d5c49c140b4bd8c0ceb8": "组名",
        "6729ad6bca8f15889334565a": "组别",
        "68931bd4821f239505a856da": "组别",
        "69644ed3eef6c246fc90a406": "随机分组",
        "6976f995ae36518830df073a": "随机分组"
      },
      projectDateMap: {
        "63919eaef86d0682b94669fd": "签署知情时间",
        "678f3c9def2164132767c5c8": "签署知情时间",
        "63410c94eaea91a48060aeb8": "随机日期",
        "6476ce88d477c932cf3e17bf": "随机时间",
        "6513d5c49c140b4bd8c0ceb8": "随机时间",
        "66c70559fc0a6b41e1351831": "随机时间",
        "66cbf3c0fc0a6b41e1352826": "知情同意书签署日期",
        "6729ad6bca8f15889334565a": "随机时间",
        "67ede6da43107079f586f07b": "知情同意书签署日期",
        "6a3a51fa04ac36255ee907c3": "知情时间",
        "6a3dd4ec24f5db851d8016b9": "随机时间",
        "6a66c6715f164366b3de026c": "随机时间",
        "678f3c9def2164132767c5c8": "签署知情时间"
      },
      envName: sessionStorage.getItem("iwrs_environment"),
      hideProjectList: [
        "62f9f0dcc43d533bd20f99a1",
        "62970c755a08ad1af5d3295f",
        "62b913e631c5eca8a702970d",
        "63734473ccd197d402a938fd",
        "64096d9e864ff9db7cee37c8",
        "6419275437a4507c1d49ab08",
        "64191c906e014b193a343f28",
        "6305b6ed048cec1f511d8e06",
        "6476bc96ad1ad354ffb4b15c",
        "64e843888dfa6a8de671cdff",
        "6513d5c49c140b4bd8c0ceb8",
        "6528e3569c140b4bd8c79dd7",
        "6593830598972b5989056c2b",
        "661892a3a5957e087c613555",
        "676a26d1e38a8ebcd771a00b",
        "691db272acc1e865824ab578",
        "69644ed3eef6c246fc90a406",
        "6976f995ae36518830df073a",
        "6aa222ac1c6db8088da6b552"
      ],
      UATHideProjectList: [
        "64096d9e864ff9db7cee37c8",
        "63db10fabbae4962a9dadbd2",
        "6419275437a4507c1d49ab08",
        "64191c906e014b193a343f28"
      ]
    };
  },
  computed: {},
  watch: {
    subject(newV, oldV) {
      this.getSubjectLogs();
    },
    immediate: true,
    deep: true
  },
  created() {
    // 获取日志列表
    this.getSubjectLogs();
  },
  methods: {
    getSubjectLogs() {
      // 获取日志列表
      const params = {
        project_id: this.project.id,
        id: this.subject.id
      };
      subjectLogs(this, params, res => {
        this.log_list = res.data;
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    goPrint() {
      printJS({
        printable: "print-look",
        type: "html",
        header: "受试者记录",
        headerStyle: "text-align:center;color:#f00;width:100%;",
        targetStyles: ["border", "padding: 15px"],
        scanStyles: false,
        style: `.tableBox {
  width: 100%;
  border-collapse: collapse;
  border: 2px solid #000;
  text-align: center;
}
.tableTr {
  width: 100%;
}

.tableTr td {
  width: 25%;
  height: 50px;
}
.tableHr{
  height: 15px;
  border: 2px solid #000;
}` // 表格样式
      });
    }
  }
};
